module.exports = __webpack_public_path__ + "assets/4ae10aff9535596554ab417184d6165a.png";